// extracted by mini-css-extract-plugin
export default {"container":"style_container__Ri1ae","devider":"style_devider__TS5Xp"};